import React, {useCallback, useState} from "react";
import {View, Text} from "react-native";
import {ButtonType} from "../theme";
import {Button} from "../components";
import useAuth from "../contexts/Auth/useAuth";
import {useAppContext} from "../contexts/AppContext";
import {addErrorEntry} from "../utils/errorFormHandlers";


interface ShareButtonProps {
    disable: boolean;
    onShare: () => Promise<void>; // must return a Promise
    setGlobalError?: (msg: string) => void;
}


const ShareButton: React.FC<ShareButtonProps> = ({onShare, disable, setGlobalError}) => {
    const {setErrorItems, errorItems, authUpdate, setAuthUpdate, saveStatus, setSaveStatus} = useAppContext();
    const {passportData, setPassportData} = useAuth();
    const {user, profileMoods, setProfileMoods} = useAuth();
    const [loading, setLoading] = useState(false);
    const [shareButtonError, setShareButtonError] = useState<string>("");

    const onSubmit = useCallback(async () => {
        setLoading(true);

        try {
            if (onShare) {
                await onShare();
            }
        } catch (error: any) {
            const fallbackMsg = "Sorry, data can't be persisted or mail app failed";
            console.error("Share error:", error);

            setGlobalError?.(fallbackMsg);
            setShareButtonError(fallbackMsg); // <- add this line

            const newErrors = addErrorEntry(errorItems, {
                key: "global",
                message: fallbackMsg,
                tab: "Share"
            });
            setErrorItems(newErrors);
        } finally {
            setLoading(false);
        }
    }, [user?.token]);

    return (
      <View
        style={{
            paddingTop: 20,
            justifyContent: "center",
            alignItems: "center",
        }}
      >
          <Button
            title={"Share Passport"}
            disabled={disable}
            onPress={onSubmit}
            loading={loading}
            variant={ButtonType.secondary}
          />
          {setGlobalError && shareButtonError !== "" && (
            <Text style={{ color: 'red', marginTop: 10 }}>{shareButtonError}</Text>
          )}
      </View>
    );
};

export default ShareButton;
